function DateFilter(moment) {
	'ngInject';

	return function (date, format) {
		if (moment(date).isValid()) {
			return moment(date).tz('Europe/Sofia').format(format);
		} else {
			return date;
		}
	};
}

export default DateFilter;



/** WEBPACK FOOTER **
 ** ./client/components/date-parser/date.filter.js
 **/